import request from 'api/request';

export default function destroyQuestionRoute({ courseId, field, index }) {
  return request({
    url: `/courses/${courseId}/${field}/${index}`,
    method: 'DELETE',
  });
}
